import React from 'react'
import './about.css'
import ME from '../../assets/images/me-about.png'
import { BsCodeSlash } from 'react-icons/bs'
import { MdDeveloperMode } from 'react-icons/md'
import { SiCodersrank } from 'react-icons/si'
import { Link } from 'react-router-dom'

const About = () => {
  const cardData = [
    {
      id: 1,
      icon: <BsCodeSlash className="about__icon" />,
      title: 'Coding',
      count: '500+ Questions'
    },
    {
      id: 2,
      icon: <MdDeveloperMode className="about__icon" />,
      title: 'Projects',
      count: '10+ Projects'
    },
    {
      id: 3,
      icon: <SiCodersrank className="about__icon" />,
      title: 'CP',
      count: '30+ Contests'
    }
  ]

  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="about me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            {cardData.map(card => (
              <article className="about__card" key={card.id}>
                {card.icon}
                <h5>{card.title}</h5>
                <small>{card.count}</small>
              </article>
            ))}
          </div>
        </div>
        <div className="about__text">
          <p>
            👋 Hi, my name is Raj Gupta, from Shahdol, MP, India.
            <br />
            I'm a Final Year Student at SGSITS, Indore Pursuing Computer Science Engineering.
            <br />
            I'm a Web developer & Programmer who loves to write clean and efficient code. A Machine Learning and Problem Solving Enthusiats
            <br />
            I love Fitness, Playing chess and Reading Self help Books.
          </p>
          {window.screen.width > 600 ? (
            <Link to="/contact" className="btn btn-primary">
              Let's Talk
            </Link>
          ) : (
            <a href="#contact" className="btn btn-primary">
              Let's Talk
            </a>
          )}
        </div>
      </div>
    </section>
  )
}

export default About
